<ng-content></ng-content>
@if (showClear) {
  <button class="btn btn-icon rounded-1" (click)="clear.emit()">
    <fa-icon [icon]="clearIcon"></fa-icon>
  </button>
}
